import { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const PortfolioPage = lazy(() => import('./pages/PortfolioPage'));
const ResourcePlanningPage = lazy(() => import('./pages/ResourcePlanningPage'));
const TemplatesPage = lazy(() => import('./pages/TemplatesPage'));
const RisksPage = lazy(() => import('./pages/RisksPage'));
const IssuesPage = lazy(() => import('./pages/IssuesPage'));
const ChangeRequestsPage = lazy(() => import('./pages/ChangeRequestsPage'));

export const AdvancedRoutes: RouteObject = {
  path: 'advanced',
  element: <ModuleGuard moduleId="projects.advanced" />,
  handle: { crumb: 'Advanced PMO' },
  children: [
    { path: '', element: <Navigate to="portfolio" replace /> },
    { path: 'portfolio', element: <PortfolioPage />, handle: { crumb: 'Portfolios' } },
    { path: 'resource-planning', element: <ResourcePlanningPage />, handle: { crumb: 'Resource Planning' } },
    { path: 'templates', element: <TemplatesPage />, handle: { crumb: 'Templates' } },
    { path: 'risks', element: <RisksPage />, handle: { crumb: 'Risks' } },
    { path: 'issues', element: <IssuesPage />, handle: { crumb: 'Issues' } },
    { path: 'change-requests', element: <ChangeRequestsPage />, handle: { crumb: 'Change Requests' } },
  ],
};

export default AdvancedRoutes;
